import styled from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide-v20';

import { BaseCol } from '../style';

interface IBaseColProps {
  disabled: boolean;
  active: boolean;
}

export const StyledIconColumn = styled(BaseCol)`
  align-items: center;
  justify-content: center;

  label {
    display: inline;
    padding-left: 0;
    padding-right: 1.25rem;
    bottom: 0.625rem;
  }

  @media (min-width: ${breakpoints.sm}) {
    justify-content: flex-end;
  }
`;

export const StyledTextColumn = styled(BaseCol)<IBaseColProps>`
  align-items: center;
  vertical-align: center;

  color: ${({ disabled }) => (disabled ? theme.color.text.disabled : theme.color.text.primary)} !important;
`;

export const StyledAdditionalInfoColumn = styled(BaseCol)`
  align-items: center;
  vertical-align: center;
`;

export const StyledInfoColumn = styled(BaseCol)<IBaseColProps>`
  align-items: center;
  vertical-align: center;

  color: ${({ disabled }) => (disabled ? theme.color.text.disabled : theme.color.text.tertiary)};

  a {
    color: ${({ disabled }) => (disabled ? theme.color.text.disabled : theme.color.text.tertiary)};
  }
`;

export const StyledPriceColumn = styled(BaseCol)<IBaseColProps>`
  justify-content: flex-end;
  align-items: center;
  font-size: 0.875rem;
  font-weight: bold;
  order: 3;
  margin-left: auto;

  color: ${({ active, disabled }) => (active && !disabled ? theme.color.text.primary : theme.color.text.disabled)};

  @media (min-width: ${breakpoints.sm}) {
    order: initial;
    margin-left: initial;
  }
`;

export const StyledPricePerPieceColumn = styled(BaseCol)`
  visibility: hidden;

  @media (min-width: ${breakpoints.sm}) {
    visibility: visible;
    justify-content: flex-end;
    align-items: center;
    font-size: 0.875rem;
    font-weight: bold;
  }
`;

export const StyledQuantityColumn = styled(BaseCol)`
  align-items: center;
  justify-content: flex-start;

  @media (min-width: ${breakpoints.sm}) {
    justify-content: center;
  }
`;

export const StyledButtonCol = styled(BaseCol)`
  align-items: center;
  order: 2;
  justify-content: flex-end;
  margin-left: auto;

  @media (min-width: ${breakpoints.sm}) {
    justify-content: flex-start;
    order: initial;
    margin-left: initial;
  }

  @media (min-width: ${breakpoints.md}) {
    justify-content: center;
  }
`;
